import { requestHttp } from "../utils/HttpRequest";

export const getRecommended = (customerId) => {
  try {
    const response = requestHttp({
      endpoint: "recommended_unsold",
      data: {
        customer_id: customerId,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
